import { TOGGLE_MODAL } from "editor/actions/ui";
import { GET_ITEM_SUCCEEDED, GET_ITEM_REQUESTED } from "actions/items";

import { EDITOR_MODALS } from "config/constants/editor";

const initialState = {
  isLoading: false,
  openModal: EDITOR_MODALS.CLOSE,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_MODAL:
      return {
        ...state,
        openModal: action.payload,
      };
    case GET_ITEM_REQUESTED:
      return {
        ...state,
        isLoading: true,
      };
    case GET_ITEM_SUCCEEDED:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
}
